import { render, staticRenderFns } from "./JdsNametag.vue?vue&type=template&id=68b23e9e&scoped=true&"
import script from "./JdsNametag.vue?vue&type=script&lang=ts&"
export * from "./JdsNametag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b23e9e",
  null
  
)

export default component.exports